/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-23 15:00:50
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-13 12:39:25
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/slice/index.ts
 */
import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';

import {
  onCollapseOpen as _onCollapseOpen,
  assData,
  hasError,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';

import {
  generateDefaultState as _generateDefaultState,
  defaultStatus,
} from 'src/pages/SalesChannelContentEditor/slice/reduxCommonFunctions';
import {
  EnumReducers,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getHasModified as _getHasModified,
  getLoaded as _getLoaded,
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getState as _getState,
  getSubmitStamp as _getSubmitStamp,
} from 'src/pages/SalesChannelContentEditor/slice/selectors'; //   getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,

import { EnumCollapseId } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/common';
export { EnumCollapseId };

import { msg } from 'src/tools/message';

import {
  getContentShoppingCart,
  getContentShoppingCartResetConfig,
  postContentShoppingCart,
} from '@/src/request/salesChannel/content';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { isCurrentPrimary } from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  convertDataFromServerToRedux,
  fixedCollapse,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorShoppingCartPage/tools';
import { getState as storeGetState } from 'src/store';

export const fetchContentShoppingCart = createAsyncThunk(
  'fetchSalesChannelContentShoppingCartPage',
  async (data: any) => {
    const { uuid, params = {}, isClone } = data;
    const isPrimary = isCurrentPrimary();
    const response = await getContentShoppingCart(uuid, params);
    return { response, isPrimary, isClone };
  },
);

export const submitContentShoppingCart = createAsyncThunk(
  'submitSalesChannelContentShoppingCartPage',
  async ({ body, params }: any) => {
    const isPrimary = isCurrentPrimary();
    const response = await postContentShoppingCart(body, params);
    return { response, isPrimary };
  },
);

export const fetchContentShoppingCartResetConfig = createAsyncThunk(
  'fetchContentShoppingCartResetConfig',
  async (data: any) => {
    //getButtonStyleAndDefaultData
    const state = storeGetState();
    const { uuid } = getButtonStyleAndDefaultData()(state);
    const { resetKey, params = {} } = data;
    const response = await getContentShoppingCartResetConfig(uuid, params);
    return { resetKey, response };
  },
);

const _defaultState = _generateDefaultState(fixedCollapse);

const defaultState = {
  ..._defaultState,
  ...defaultStatus,
  emptyStateSetting: {
    image: null,
    text: '',
    background: '#ffffff',
  },
  featuredProducts: { titleTextColor: '#000000' },
  buttonStyle: { text: '', backgroundColor: '#000000', textColor: '#000000' },
  noticeBoard: { enabled: false },
  resetValues: null,
  loaded: false,
};
const salesChannelContentShoppingCartPage = createSlice({
  name: 'salesChannelContentShoppingCartPage',
  initialState: defaultState,
  reducers: {
    resetData(state) {
      assData(state, defaultState);
    },
    onButtonTextChange(state, action) {
      state.hasModified = true;
      state.buttonStyle = { ...state.buttonStyle, ...action.payload };
    },
    onNoticeBoardChange(state, action) {
      state.hasModified = true;
      state.noticeBoard = { ...state.noticeBoard, ...action.payload };
    },
    onEmptyStateSetting(state, action) {
      state.hasModified = true;
      state.emptyStateSetting = {
        ...state.emptyStateSetting,
        ...action.payload,
      };
    },
    onCollapseOpen(state, action) {
      const { idArr = [] } = action.payload; //=>[id:string]
      _onCollapseOpen(state, idArr);
    },
    onErrorChange(state, action) {
      const { id, status } = action.payload;
      state.collapseErrorMsgDisplay[id].hasError = status;
    },
    onFeaturedProductChange(state, action) {
      state.hasModified = true;

      state.featuredProducts.titleTextColor = action.payload;
    },
    validation(state) {
      hasError(state, state.collapseErrorMsgDisplay || {});
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchContentShoppingCart.fulfilled, (state, action) => {
      const { response, isClone } = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};

      assData(state, _data);
      if (isClone) state.hasModified = true;
    });

    builder.addCase(submitContentShoppingCart.fulfilled, (state, action) => {
      const { response } = action.payload;
      const _data = convertDataFromServerToRedux(response) || {};
      msg.success(getI18nFromGeneral('general.status.changessavesuccessfully'));
      assData(state, { ..._data });
    });
    builder.addCase(
      fetchContentShoppingCartResetConfig.fulfilled,
      (state, action) => {
        const { response, resetKey } = action.payload;
        state.resetValues = response;
        state[resetKey] = response[resetKey];
        // if (!state.resetValues) {
        //   state.resetValues = response;
        //   state[resetKey] = response[resetKey];
        // }
      },
    );
  },
});

export const getLoaded = () => {
  return _getLoaded(EnumReducers.shoppingCartPage);
};

export const getSubmitStamp = () => {
  return _getSubmitStamp(EnumReducers.shoppingCartPage);
};

export const getCollapseOpenStatus = (id) => {
  return _getCollapseOpenStatus(EnumReducers.shoppingCartPage, id);
};

export const getCollapseValidationMsgDisplay = (id) => {
  return _getCollapseValidationMsgDisplay(EnumReducers.shoppingCartPage, id);
};

export const getGeneralFeaturedProduct = () => {
  return _getGeneralFeaturedProduct(EnumReducers.shoppingCartPage);
};

export const getState = () => {
  return _getState(EnumReducers.shoppingCartPage);
};

export const getHasModified = () => {
  return _getHasModified(EnumReducers.shoppingCartPage);
};

export const getSalesChannel = () => {
  return _getSalesChannel(EnumReducers.shoppingCartPage);
};

export const getSalesChannelName = () => {
  return _getSalesChannelName(EnumReducers.shoppingCartPage);
};

export const getButtonStyle = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].buttonStyle,

    (buttonStyle) => {
      return buttonStyle;
    },
  );
};

export const getButtonStyleAndDefaultData = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].buttonStyle,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].resetValues,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].uuid,
    (buttonStyle, resetValue, uuid) => {
      return { buttonStyle, resetValue, uuid };
    },
  );
};

export const getEmptyStateSettingAndDefaultData = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage]
        .emptyStateSetting,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].resetValues,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].uuid,
    (emptyStateSetting, resetValue, uuid) => {
      return { emptyStateSetting, resetValue, uuid };
    },
  );
};

export const getEmptyStateSetting = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage]
        .emptyStateSetting,
    (emptyStateSetting) => {
      return emptyStateSetting;
    },
  );
};

export const getNoticeBoard = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].noticeBoard,

    (noticeBoard) => {
      return noticeBoard;
    },
  );
};

export const getContent = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage]
        .emptyStateSetting,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].featuredProducts,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].buttonStyle,
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].noticeBoard,
    (emptyStateSetting, featuredProducts, buttonStyle, noticeBoard) => {
      return {
        emptyStateSetting,
        featuredProducts,
        buttonStyle,
        noticeBoard,
      };
    },
  );
};

export const isNoticeBoardOpening = () => {
  return createSelector(
    (state: any) =>
      state.salesChannelContent[EnumReducers.shoppingCartPage].collapseOpen[
        EnumCollapseId.noticeBoard
      ],
    (open) => {
      return open;
    },
  );
};

export const {
  resetData,
  onButtonTextChange,
  onCollapseOpen,
  onEmptyStateSetting,
  onErrorChange,
  onFeaturedProductChange,
  validation,
  onNoticeBoardChange,
} = salesChannelContentShoppingCartPage.actions;

export default salesChannelContentShoppingCartPage.reducer;
